module.exports = ".ticketView {\n  margin-bottom: 18px;\n  font-size: 13px;\n  min-height: 15cm;\n}\n\n.ticketView.dotted {\n  border-bottom: 1px dashed #cccccc;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/tickets/print/print.component.css
// module id = ./src/app/tickets/print/print.component.css
// module chunks = main